export default "__VITE_ASSET__BF6VBR5s__"